import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

const main = `${BASE_URL}api/entity/`;

export const ENTITY_ENDPOINTS = {
  main,
  byId: (id) => `${main}${id}/`,
  byCode: (id) => `${main}${id}/?by_code=true`,
  export: `${main}export/`,
  model_export: `${main}model_export/`,
  suggestedMembers: `${main}suggested-members/`,
};

class Entities {
  async getAllEntities(query={per_page: 9999}) {
    const { data } = await request({ url: ENTITY_ENDPOINTS.main, query });
    return data;
  }
  async getOptions() {
    const { data } = await request({
      url: ENTITY_ENDPOINTS.byId("possible-options"),
      method: "GET",
    });
    return data;
  }

  async getContexteOptions() {
    const { data } = await request({
      url: ENTITY_ENDPOINTS.byId('contexte-options'),
      method: 'GET'
    });
    return data
  }

  async getSuggestedMembers(id, category) {
    const { data } = await request({
      url: ENTITY_ENDPOINTS.suggestedMembers,
      method: "POST",
      body: {
        entity_ids: id,
        category
      },
    });
    return data;
  }

  async handleEntitiesCategoriesEdit(entityIds, payload, updatedFields) {
    return await request({
      url: ENTITY_ENDPOINTS.byId("bulk"),
      method: "PATCH",
      body: {
        entities: entityIds,
        changed_fields: updatedFields,
        payload,
      },
    });
  }
  async getEntity(id, byCode = false) {
    const { data } = await request({
      url: byCode ? ENTITY_ENDPOINTS.byCode(id) : ENTITY_ENDPOINTS.byId(id),
      method: "GET",
    });
    return data;
  }
  async deleteEntity(id) {
    await request({
      url: ENTITY_ENDPOINTS.byId(id),
      method: "DELETE",
    });
  }
  async editOrCreateEntity(id = null, payload = {}) {
    const isEdit = id && id !== "create";
    const { res, data } = await request({
      url: isEdit ? ENTITY_ENDPOINTS.byId(id) : ENTITY_ENDPOINTS.main,
      method: isEdit ? "PUT" : "POST",
      body: payload,
    });
    return { res, data };
  }
}

export const EntitiesService = new Entities();
